import { IDocumentLink } from '@/store/models/shared.model';

export enum IBulkCardCreationStatus {
  COMPLETE = 'COMPLETE',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  COMPLETE_WITH_ERROR = 'COMPLETE_WITH_ERROR',
}

export interface IBulkCardReportDownload extends IDocumentLink {}

export const cardsMediums = {
  PHYSICAL: {
    label: 'physical',
    value: 1,
  },
  VIRTUAL: {
    label: 'virtual',
    value: 2,
  },
  VIRTUAL_CONVERTED: {
    label: 'virtualConverted',
    value: 3,
  },
} as const;

export type TCardsMediumsKeys = keyof typeof cardsMediums;
export type TCardsMediumsLabels = (typeof cardsMediums)[TCardsMediumsKeys]['label'];
export type TCardsMediumsValues = (typeof cardsMediums)[TCardsMediumsKeys]['value'];

export function isValidCardMedium(value: number | string): value is TCardsMediumsValues {
  return Object.values(cardsMediums)
    .map((medium) => medium.value)
    .includes(parseInt(value.toString(), 10) as TCardsMediumsValues);
}

export interface IBulkCard {
  orderId?: string;
  errors?: string[];
  status?: IBulkCardCreationStatus;
  walletIdAttach?: number;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  createWalletForEach?: boolean;
  walletTypeId?: number;
  userIdOwner?: number;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  createUserForEach?: boolean;
  number?: number;
  defaultMccRestrictionGroupId?: number;
  defaultMerchantRestrictionGroupId?: number;
  defaultCountryRestrictionGroupId?: number;
  defaultPermsGroup?: string;
  packageId?: string;
  logoId?: string;
  designCode?: string;
  anonymous?: number;
  cardPrint?: string;
  designType?: 'virtual' | 'physical';
  paymentDailyLimit?: number;
  limitPaymentAll?: number;
  limitPaymentDay?: number;
  limitPaymentWeek?: number;
  limitPaymentMonth?: number;
  limitPaymentYear?: number;
  limitAtmAll?: number;
  limitAtmDay?: number;
  limitAtmWeek?: number;
  limitAtmMonth?: number;
  limitAtmYear?: number;
  medium?: TCardsMediumsValues;
  createdAt?: string;
  cardDeliveryAddress1?: string;
  cardDeliveryAddress2?: string;
  cardDeliveryAddress3?: string;
  cardDeliveryPostCode?: string;
  cardDeliveryCity?: string;
  cardDeliveryState?: string;
  cardDeliveryCountry?: string;
  distributionCountry?: string;
  batchDeliveryId?: number;
}
